/** 유아 콧물 흡입기 — 제품 디자인 케이스 데이터 */

export const INFANT_NASAL_ASPIRATOR_SLUG = 'infant-nasal-aspirator'

export const INFANT_NASAL_ASPIRATOR_SHEET_IMG =
    '/assets/img/design/infant-nasal-aspirator-sheet.png'
export const INFANT_NASAL_ASPIRATOR_PROCESS_IMG =
    '/assets/img/design/infant-nasal-aspirator-process.png'
export const INFANT_NASAL_ASPIRATOR_CONCEPT_SPEC_IMG =
    '/assets/img/design/infant-nasal-aspirator-concept-spec.png'
export const INFANT_NASAL_ASPIRATOR_LIFESTYLE_IMG =
    '/assets/img/design/infant-nasal-aspirator-lifestyle.png'

export const infantNasalAspiratorPortfolioCard = {
    slug: INFANT_NASAL_ASPIRATOR_SLUG,
    title: '유아 콧물 흡입기',
    excerpt:
        '곰·고래 캐릭터 라인 — 아이가 무서워하지 않는 둥근 형태, LED 인디케이터·실리콘 흡입부를 갖춘 유아용 흡입기입니다.',
    image: INFANT_NASAL_ASPIRATOR_LIFESTYLE_IMG,
    imageAlt: '유아 콧물 흡입기 — 곰·고래 캐릭터, 아이 방 라이프스타일',
    year: '2023',
    tags: ['유아용', '헬스케어', '캐릭터 디자인'],
}

const infantNasalAspiratorShowcases = [
    {
        id: 'infant-nasal-process',
        kicker: 'Design process',
        title: '리서치 · 스케치 · 포지셔닝',
        tagline: '콧물 흡입기',
        image: INFANT_NASAL_ASPIRATOR_PROCESS_IMG,
        imageAlt:
            '유아 콧물 흡입기 디자인 프로세스 — 수동·전동 시장 조사, 친화적 스케치, 포지셔닝 차트',
        description: [
            '수동식(휴대·저가·효과 제한)과 전동식(노시부·코코클린 등 동물 캐릭터) 시장을 비교했습니다. 영유아는 스스로 코를 풀 수 없어 호흡·수유에 영향을 주므로, 거부감·공포 없이 쓸 수 있는 친화적 디자인을 목표로 했습니다.',
            '유아를 위한 친근한 콘셉트 스케치로 곰·펭귄형 등 둥근 캐릭터를 도출하고, 고가형·친화적(캐릭터) 영역을 개발 목표로 포지셔닝했습니다.',
        ],
        features: [
            {
                title: '시장 리서치',
                text: '수동·전동 제품군을 분석해 효과·가격·캐릭터 차별화 요소를 정리했습니다.',
            },
            {
                title: '사용자 맥락',
                text: '주 사용자가 영유아임을 전제로 부모·아이 모두 부담 없는 UX를 설정했습니다.',
            },
            {
                title: '캐릭터 스케치',
                text: 'LED·다이얼·흡입 컵·전원선 등 기능을 스케치에 반영했습니다.',
            },
            {
                title: '포지셔닝',
                text: '저가형 심플 다수 시장에서 고가형·친화적 캐릭터 포지션을 목표로 했습니다.',
            },
        ],
    },
    {
        id: 'infant-nasal-concept',
        kicker: 'Concept · Spec',
        title: '디자인 컨셉 · 제품 스펙',
        tagline: '곰 · 고래 라인',
        image: INFANT_NASAL_ASPIRATOR_CONCEPT_SPEC_IMG,
        imageAlt:
            '유아 콧물 흡입기 — 곰·고래 3D 컨셉, 인디케이터·거치대·흡입기 콜아웃, 와이어프레임 스펙',
        description: [
            '핑크·화이트 곰 라인은 전면 LED 눈·큰 다이얼로 출력 단계를 표현하고, 라이트 블루 고래 라인은 상단 물뿜음 형 인디케이터·꼬리 거치대로 친숙함을 더했습니다.',
            '제품 스펙 와이어프레임으로 곰·고래 두 볼륨의 치수·부품 배치를 CAD 단계에서 검증했습니다.',
        ],
        features: [
            {
                title: 'LED 인디케이터',
                text: '곰의 눈·다이얼 LED는 출력 단계에 따라 색이 변해 아이의 시선을 끕니다.',
            },
            {
                title: '고래 거치대',
                text: '꼬리 형태를 노즐·튜브 거치 기능으로 활용했습니다.',
            },
            {
                title: '물뿜음 인디케이터',
                text: '고래 상단 인디케이터를 물뿜음 형태로 만들어 친숙한 피드백을 제공합니다.',
            },
            {
                title: '흡입기 형상',
                text: '흡입 부속을 캐릭터 꼬리처럼 보이게 해 장난감 같은 인상을 줍니다.',
            },
        ],
    },
    {
        id: 'infant-nasal-lifestyle',
        kicker: 'Lifestyle',
        title: '유아 콧물 흡입기',
        tagline: '아이 방 · 곰 & 고래',
        image: INFANT_NASAL_ASPIRATOR_LIFESTYLE_IMG,
        imageAlt:
            '유아 콧물 흡입기 곰·고래 — 밝은 아이 방, 티피텐트·책·램프와 함께 배치',
        description: [
            '화이트 매트·파스텔 핑크·라이트 블루 톤으로 아이 방 인테리어와 자연스럽게 어울리도록 연출했습니다. 곰·고래 두 라인을 나란히 배치해 제품군 확장을 보여 줍니다.',
            '부드러운 자연광과 미니멀 소품(램프·책·티피)으로 안전하고 따뜻한 사용 환경을 전달했습니다.',
        ],
        features: [
            {
                title: '듀얼 캐릭터 CMF',
                text: '곰(핑크)·고래(블루) 두 컬러웨이로 성별·취향 선택을 넓혔습니다.',
            },
            {
                title: '매트 소재감',
                text: 'ABS·실리콘 매트 마감으로 부드럽고 안전한 터치 이미지를 유지합니다.',
            },
            {
                title: '투명 튜브·컵',
                text: '위생·사용 상태를 확인할 수 있는 투명 부속을 연결했습니다.',
            },
            {
                title: '공간 스토리',
                text: '실제 아이 방 맥락에서 의료기기가 아닌 생활 가전처럼 놓이게 했습니다.',
            },
        ],
    },
]

const infantNasalAspiratorProcessPhases = [
    {
        id: 'research',
        title: '리서치 & 문제 정의',
        lede: '영유아 콧물 제거 필요성과 시장의 수동·전동 제품군을 분석했습니다.',
        body: '전동식은 효과는 높지만 가격이 높고, 동물 캐릭터로 아이의 공포를 줄이는 방향이 주류입니다. 친화적 디자인이 핵심 차별점임을 도출했습니다.',
    },
    {
        id: 'concept',
        title: '캐릭터 콘셉트',
        lede: '둥글고 부드러운 곰·고래 캐릭터로 무서움을 줄이는 형태를 설계했습니다.',
        body: '아이들이 무서워하지 않고 사용할 수 있도록 단순한 눈·뺨·다이얼 UI를 적용했습니다. 콧속 콧물을 흡입·제거해 코를 편안하게 해 주는 역할을 형태 언어로 표현했습니다.',
    },
    {
        id: 'spec',
        title: '스펙 & 구조',
        lede: '140×147×158(mm), ABS·SILICON 재질 기준으로 볼륨을 정리했습니다.',
        body: '와이어프레임으로 곰·고래 두 모델의 치수·LED·다이얼·튜브·흡입부 배치를 검증했습니다. 고래 꼬리 거치·물뿜음 인디케이터 등 기능 디테일을 반영했습니다.',
    },
    {
        id: 'viz',
        title: '시각화',
        lede: 'Rhinoceros·KeyShot·Photoshop으로 시트·프로세스·라이프스타일 렌더를 제작했습니다.',
        body: '제품 시트, 디자인 프로세스 보드, 컨셉·스펙 보드, 아이 방 라이프스타일 컷으로 갤러리·상세·마케팅 산출물을 구성했습니다.',
    },
]

export const infantNasalAspiratorDesignCase = {
    pageTitle: '유아 콧물 흡입기',
    masthead: '유아 콧물 흡입기',
    mastheadSub: 'Infant nasal aspirator',
    showcaseSectionTitle: '제품 특징 · 디자인 프로세스',
    metaDescription:
        '유아 콧물 흡입기 — 곰·고래 캐릭터, LED 인디케이터, 친화적 제품 디자인·목업, Rhino·KeyShot 사례입니다.',
    meta: {
        client: '유아 헬스케어',
        year: '2023',
        scope: '제품 디자인 · Rhinoceros · KeyShot · Photoshop',
        size: '140 × 147 × 158 (mm)',
        material: 'ABS, SILICON',
    },
    intro: {
        lead: '아이들이 무서워하지 않고 사용할 수 있는 콧물 흡입기입니다. 둥글고 부드러운 캐릭터 디자인이 핵심입니다.',
        left: '아이 콧속 콧물을 제거하고 코를 편안하게 해 주는 장비로, 불편함·공포를 줄이는 것이 목표입니다. 곰(핑크)·고래(블루) 두 캐릭터 라인으로 선택 폭을 넓혔습니다.',
        right: '제품 시트로 두 라인 개요를, 프로세스 보드로 시장·스케치·포지셔닝을, 컨셉·스펙 보드로 기능 콜아웃과 치수를, 라이프스타일 컷으로 아이 방 사용 맥락을 전달합니다.',
    },
    hero: {
        src: INFANT_NASAL_ASPIRATOR_SHEET_IMG,
        alt: '유아 콧물 흡입기 제품 시트 — 곰·고래 캐릭터 3D 렌더',
    },
    productShowcases: infantNasalAspiratorShowcases,
    processPhases: infantNasalAspiratorProcessPhases,
    deliverables: [
        '유아용 캐릭터 콘셉트·곰·고래 라인 스케치',
        '시장 리서치·디자인 포지셔닝 정리',
        'Rhinoceros 3D·와이어프레임 스펙',
        'KeyShot 컨셉·라이프스타일 렌더',
        '제품 스펙 시트(140×147×158 mm · ABS/SILICON · 2023)',
        'Photoshop 프로세스·프레젠테이션 보드',
    ],
    outro: [
        '의료·케어 기기도 캐릭터 CMF로 아이와 부모의 심리적 부담을 낮출 수 있습니다.',
        '유아 콧물 흡입기는 리서치부터 듀얼 캐릭터 라인·스펙까지 이어진 헬스케어 제품 디자인 사례입니다.',
        '코담디자인은 유아·가족용 제품의 형태·캐릭터·렌더 시각화를 지원합니다.',
    ],
}
